<template>
  <vx-card
    :title="$t('teacher.title')"
    class="mb-base p-1 " title-color="primary"
  >
    <template slot="actions">
      <div class="flex justify-end">
        <vs-button radius color="success" type="border" icon="keyboard_backspace"
        @click="goBack">
        </vs-button>
      </div>
    </template>

    <vs-avatar
      :src="teacherProfile" class="mx-auto mb-6 block"
      size="160px"/>
    <div class="text-center">
      <h4>
        {{ teacher | personName }}
      </h4>
    </div>

    <template slot="footer">
      <vs-divider/>
      <div class="flex flex-col justify-start">

        <span v-if="teacher.telephone" class="flex items-center">
          <vs-avatar color="primary" icon="smartphone" />
          <span class="ml-2"> {{ teacher.telephone }} </span>
        </span>

        <span v-if="teacher.email" class="flex items-center">
          <vs-avatar color="success" icon="email" />
          <span class="ml-2"> {{ teacher.email }} </span>
        </span>

        <span v-if="teacher.socialMedia" class="flex items-center">
          <vs-avatar color="danger" icon="link"></vs-avatar>
          <span class="ml-2"> {{ teacher.socialMedia }} </span>
        </span>

        <span v-if="teacher.availableTime" class="flex items-center">
            <vs-avatar color="warning" icon="alarm"> </vs-avatar>
          <span class="ml-2"> {{ teacher.availableTime }} </span>
        </span>

      </div>
    </template>
  </vx-card>
</template>

<script>
import {getAvatarUrl} from "@/utils/upload";

export default {
  name: "TeacherProfile",
  props: ['teacher'],
  computed: {
    teacherProfile() {
      return getAvatarUrl(this.teacher ? this.teacher.picturePath : '');
    }
  },
  methods:{
    goBack(){
     this.$router.push('/');
    }
  }
}
</script>

<style scoped>

</style>
